/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-len */
import { motion, useSpring, useTransform, useInView, AnimatePresence, cubicBezier, useAnimate, stagger } from 'framer-motion';
import { useRef, useState, useEffect, useContext } from 'react';
import { useInViewScroll, MotionImage, useSanitizedTranslation, PromoBlock, XumoButton as Button, StackedContent, TextBlock } from 'ui';
import Image from 'next/image';

export interface Img {
  src: string;
  alt: string;
  width: number;
  height: number;
}

export interface TwoColTxtImgProps {
  content: any;
  flipped: boolean;
  image: Img[];
  imgpadding?: string;
}

export const TwoColTxtImg = ({ content, image, flipped, imgpadding}: TwoColTxtImgProps) => {

  return (
    <motion.section className={`w-full h-full flex ${flipped ? 'flex-col-reverse lg:flex-row-reverse' : 'flex-col lg:flex-row'} justify-center items-center wrapper gap-8 py-12 lg:pt-10 lg:pb-32`} data-testid={'text-section'}>
      <div className='w-full h-full px-10 lg:p-0'>
      <StackedContent
        left
        content={content}
      />
      </div>
      <div className="w-full h-max">
        <Image src={image.src} alt={image.alt||""} className="h-auto w-full" style={{padding: imgpadding ? imgpadding : 0}} width={image?.width ?? 1300} height={image?.height ?? 828}/>
      </div>
    </motion.section>
  );
};